var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-audio-control",class:_vm.classObject},[_c('button',{attrs:{"tabindex":_vm.tabIdx,"role":"switch","aria-checked":_vm.checked,"aria-label":_vm.e(_vm.labels.audioOutput)},on:{"click":_vm.handleChange}},[(_vm.isOn)?_c('span',[_vm._v("🔊")]):_c('span',[_vm._v("🔈")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3bc2aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalAudioControl.vue
// module id = null
// module chunks = 